export default function FileTitle({ title }: { title: string }) {
  return <h1 className="text-md mt-6 text-center font-bold">{title}</h1>;
}
